/* eslint-disable */
import BasicLayout from '@/layouts/basic-layout';

const meta = {
  auth: true,
};

const pre = 'dashboard-';

export default {
  path: '/dashboard',
  name: 'dashboard',
  redirect: {
    name: `${pre}console`,
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: 'console',
      name: `${pre}console`,
      meta: {
        ...meta,
        title: '主控台',
      },
      component: () => import('@/pages/dashboard/console'),
    },
    {
      path: 'console1',
      name: `${pre}console1`,
      meta: {
        ...meta,
        title: '数据分析',
      },
      component: () => import('@/pages/dashboard/console1'),
    },
    {
      path: 'console2',
      name: `${pre}console2`,
      meta: {
        ...meta,
        title: '官网数据分析',
      },
      component: () => import('@/pages/dashboard/console2'),
    },
    {
      path: 'linkOld',
      name: `${pre}linkOld`,
      meta: {
        ...meta,
        title: '前往原后台',
      },
      component: () => import('@/pages/dashboard/linkOld'),
    },
    {
      path: 'user',
      name: `${pre}user`,
      meta: {
        ...meta,
        title: '用户管理',
      },
      component: () => import('@/pages/dashboard/user'),
    },
    {
      path: 'seller',
      name: `${pre}seller`,
      meta: {
        ...meta,
        title: '代理商管理',
      },
      component: () => import('@/pages/dashboard/seller'),
    },
    {
      path: 'seller1',
      name: `${pre}seller1`,
      meta: {
        ...meta,
        title: '代理商数据统计',
      },
      component: () => import('@/pages/dashboard/seller1'),
    },
    {
      path: 'seller2',
      name: `${pre}seller2`,
      meta: {
        ...meta,
        title: '代理商财务统计',
      },
      component: () => import('@/pages/dashboard/seller2'),
    },
    {
      path: 'goods',
      name: `${pre}goods`,
      meta: {
        ...meta,
        title: '商品管理',
      },
      component: () => import('@/pages/dashboard/goods'),
    },
    {
      path: 'goods10',
      name: `${pre}goods10`,
      meta: {
        ...meta,
        title: '新品上架管理',
      },
      component: () => import('@/pages/dashboard/goods10'),
    },
    {
      path: 'goods20',
      name: `${pre}goods20`,
      meta: {
        ...meta,
        title: '热门推荐管理',
      },
      component: () => import('@/pages/dashboard/goods20'),
    },
    {
      path: 'group-goods',
      name: `${pre}group-goods`,
      meta: {
        ...meta,
        title: '组合购',
      },
      component: () => import('@/pages/dashboard/group-goods'),
    },
    {
      path: 'add-group-goods',
      name: `${pre}add-group-goods`,
      meta: {
        ...meta,
        title: '添加组合购',
      },
      component: () => import('@/pages/dashboard/group-goods/add-form'),
    },
    {
      path: 'order',
      name: `${pre}order`,
      meta: {
        ...meta,
        title: '订单管理',
      },
      component: () => import('@/pages/dashboard/order'),
    },
    {
      path: 'bill',
      name: `${pre}bill`,
      meta: {
        ...meta,
        title: '开票管理',
      },
      component: () => import('@/pages/dashboard/bill'),
    },
    {
      path: 'salary',
      name: `${pre}salary`,
      meta: {
        ...meta,
        title: '工资管理',
      },
      component: () => import('@/pages/dashboard/salary'),
    },
    {
      path: 'seckill-order',
      name: `${pre}seckill-order`,
      meta: {
        ...meta,
        title: '秒杀订单管理',
      },
      component: () => import('@/pages/dashboard/seckill-order'),
    },
    {
      path: 'order1',
      name: `${pre}order1`,
      meta: {
        ...meta,
        title: '新订单管理',
      },
      component: () => import('@/pages/dashboard/order1'),
    },
    {
      path: 'orderReturn',
      name: `${pre}orderReturn`,
      meta: {
        ...meta,
        title: '退货退款管理',
      },
      component: () => import('@/pages/dashboard/orderReturn'),
    },
    {
      path: 'order-comment',
      name: `${pre}order-comment`,
      meta: {
        ...meta,
        title: '评论管理',
      },
      component: () => import('@/pages/dashboard/order-comment'),
    },
    {
      path: 'join-us',
      name: `${pre}join-us`,
      meta: {
        ...meta,
        title: '招聘管理',
      },
      component: () => import('@/pages/dashboard/join-us'),
    },
    {
      path: 'message',
      name: `${pre}message`,
      meta: {
        ...meta,
        title: '消息管理',
      },
      component: () => import('@/pages/dashboard/message'),
    },
    {
      path: 'drp6',
      name: `${pre}drp6`,
      meta: {
        ...meta,
        title: '销售退货',
      },
      component: () => import('@/pages/drp/drp6'),
    },
    {
      path: 'drp7',
      name: `${pre}drp7`,
      meta: {
        ...meta,
        title: '销售退货明细',
      },
      component: () => import('@/pages/drp/drp7'),
    },
    {
      path: 'baseSet',
      name: `${pre}baseSet`,
      meta: {
        ...meta,
        title: '商城设置',
      },
      component: () => import('@/pages/dashboard/baseSet'),
    },
    {
      path: 'home-design',
      name: `${pre}home-design`,
      meta: {
        ...meta,
        title: '首页设置',
      },
      component: () => import('@/pages/dashboard/home-design'),
    },
    {
      path: 'global-setting',
      name: `${pre}global-setting`,
      meta: {
        ...meta,
        title: '全局设置',
      },
      component: () => import('@/pages/dashboard/global-setting'),
    },
    {
      path: 'goods-cate',
      name: `${pre}goods-cate`,
      meta: {
        ...meta,
        title: '商品分类',
      },
      component: () => import('@/pages/dashboard/goods-cate'),
    },
    {
      path: 'goods1',
      name: `${pre}goods1`,
      meta: {
        ...meta,
        title: '订单详情',
      },
      component: () => import('@/pages/dashboard/goods1'),
    },
    {
      path: 'carousel',
      name: `${pre}carousel`,
      meta: {
        ...meta,
        title: '轮播图',
      },
      component: () => import('@/pages/dashboard/carousel'),
    },
    {
      path: 'article-cate',
      name: `${pre}article-cate`,
      meta: {
        ...meta,
        title: '文章分类',
      },
      component: () => import('@/pages/dashboard/article-cate'),
    },
    {
      path: 'article',
      name: `${pre}article`,
      meta: {
        ...meta,
        title: '文章管理',
      },
      component: () => import('@/pages/dashboard/article'),
    },
    {
      path: 'video',
      name: `${pre}video`,
      meta: {
        ...meta,
        title: '视频管理',
      },
      component: () => import('@/pages/dashboard/video'),
    },
    {
      path: 'integral',
      name: `${pre}integral`,
      meta: {
        ...meta,
        title: '积分管理',
      },
      component: () => import('@/pages/dashboard/integral'),
    },
    {
      path: 'coupon',
      name: `${pre}coupon`,
      meta: {
        ...meta,
        title: '优惠券管理',
      },
      component: () => import('@/pages/dashboard/coupon'),
    },
    {
      path: 'share-image',
      name: `${pre}share-image`,
      meta: {
        ...meta,
        title: '分享区图片',
      },
      component: () => import('@/pages/dashboard/share-image'),
    },
    {
      path: 'rules',
      name: `${pre}rules`,
      meta: {
        ...meta,
        title: '规则管理',
      },
      component: () => import('@/pages/dashboard/rules'),
    },
    {
      path: 'group-buying',
      name: `${pre}group-buying`,
      meta: {
        ...meta,
        title: '团购管理',
      },
      component: () => import('@/pages/dashboard/group-buying'),
    },
    {
      path: 'bargain',
      name: `${pre}bargain`,
      meta: {
        ...meta,
        title: '砍价管理',
      },
      component: () => import('@/pages/dashboard/bargain'),
    },
    {
      path: 'notice',
      name: `${pre}notice`,
      meta: {
        ...meta,
        title: '通知公告',
      },
      component: () => import('@/pages/dashboard/notice'),
    },
    {
      path: 'resource',
      name: `${pre}resource`,
      meta: {
        ...meta,
        title: '资源管理',
      },
      component: () => import('@/pages/dashboard/resource'),
    },
    {
      path: 'resource1',
      name: `${pre}resource1`,
      meta: {
        ...meta,
        title: '资源管理1',
      },
      component: () => import('@/pages/dashboard/resource1'),
    },
    {
      path: 'express',
      name: `${pre}express`,
      meta: {
        ...meta,
        title: '快递管理',
      },
      component: () => import('@/pages/dashboard/express'),
    },
    {
      path: 'freight',
      name: `${pre}freight`,
      meta: {
        ...meta,
        title: '运费模板管理',
      },
      component: () => import('@/pages/dashboard/freight'),
    },
    {
      path: 'freight-form',
      name: `${pre}freight-form`,
      meta: {
        ...meta,
        title: '运费模板管理',
      },
      component: () => import('@/pages/dashboard/freight/form'),
    },
    {
      path: 'pickUp',
      name: `${pre}pickUp`,
      meta: {
        ...meta,
        title: '自提点管理',
      },
      component: () => import('@/pages/dashboard/pickUp'),
    },
    {
      path: 'shortcuts',
      name: `${pre}shortcuts`,
      meta: {
        ...meta,
        title: '快捷栏管理',
      },
      component: () => import('@/pages/dashboard/shortcuts'),
    },
    {
      path: 'pay1',
      name: `${pre}pay1`,
      meta: {
        ...meta,
        title: '合伙款明细',
      },
      component: () => import('@/pages/dashboard/pay1'),
    },
    {
      path: 'take',
      name: `${pre}take`,
      meta: {
        ...meta,
        title: '提现管理',
      },
      component: () => import('@/pages/dashboard/take'),
    },
    {
      path: 'shop',
      name: `${pre}shop`,
      meta: {
        ...meta,
        title: '门店管理',
      },
      component: () => import('@/pages/dashboard/shop'),
    },
    {
      path: 'merchant',
      name: `${pre}merchant`,
      meta: {
        ...meta,
        title: '经销商管理',
      },
      component: () => import('@/pages/dashboard/merchant'),
    },
    {
      path: 'merchant_notice',
      name: `${pre}merchant_notice`,
      meta: {
        ...meta,
        title: '经销商通知',
      },
      component: () => import('@/pages/dashboard/merchant_notice'),
    },
    {
      path: 'seckill',
      name: `${pre}seckill`,
      meta: {
        ...meta,
        title: '秒杀管理',
      },
      component: () => import('@/pages/dashboard/seckill'),
    },
    {
      path: 'live',
      name: `${pre}live`,
      meta: {
        ...meta,
        title: '直播管理',
      },
      component: () => import('@/pages/dashboard/live'),
    },
    {
      path: 'exam',
      name: `${pre}exam`,
      meta: {
        ...meta,
        title: '考试管理',
      },
      component: () => import('@/pages/dashboard/exam'),
    },
    {
      path: 'question',
      name: `${pre}question`,
      meta: {
        ...meta,
        title: '题库管理',
      },
      component: () => import('@/pages/dashboard/question'),
    },
    {
      path: 'study-record',
      name: `${pre}study-record`,
      meta: {
        ...meta,
        title: '学习记录',
      },
      component: () => import('@/pages/dashboard/study-record'),
    },
    {
      path: 'study-record1',
      name: `${pre}study-record1`,
      meta: {
        ...meta,
        title: '全局学习统计',
      },
      component: () => import('@/pages/dashboard/study-record1'),
    },
  ],
};
